import React, { ChangeEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Select,
  MenuItem,
  TextField,
  FormControl,
  InputLabel,
} from "@mui/material";
import { SelectChangeEvent } from "@mui/material";

const countries = [
  { code: "US", name: "United States" },
  { code: "IN", name: "India" },
  { code: "GB", name: "United Kingdom" },
  { code: "CA", name: "Canada" },
];

const currencies = [
  { code: "USD", name: "US Dollar" },
  { code: "INR", name: "Indian Rupee" },
  { code: "GBP", name: "British Pound" },
  { code: "CAD", name: "Canadian Dollar" },
];

const AddLoyalty = () => {
  const navigate = useNavigate();

  const [country, setCountry] = useState("");
  const [currency, setCurrency] = useState("");
  const [valueOfPoint, setValueOfPoint] = useState("");


  const handleCountryChange = (event: SelectChangeEvent<string>) => {
    setCountry(event.target.value);
  };

  const handleCurrencyChange = (event: SelectChangeEvent<string>) => {
    setCurrency(event.target.value);
  };

  const handleValueChange = (event: ChangeEvent<HTMLInputElement>) => {
    setValueOfPoint(event.target.value);
  };

  const handleSave = () => {
    // TODO: Add save logic here
    console.log({ country, currency, valueOfPoint });
  };

  return (
    <>
      <div className="main_title">
        <h1>Add Loyalty Point</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/loyalty-points")}>
            Loyalty Points Management
          </button>{" "}
          - Add Loyalty Point
        </p>
      </div>

      <div className="cards">
        <div className="form gap_p">
          <div className="control_group w_33">
            <FormControl fullWidth>
              <InputLabel id="country-label">Country</InputLabel>
              <Select
                labelId="country-label"
                id="country"
                value={country}
                label="Country"
                onChange={handleCountryChange}
              >
                {countries.map((c) => (
                  <MenuItem key={c.code} value={c.code}>
                    {c.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          <div className="control_group w_33">
            <FormControl fullWidth>
              <InputLabel id="currency-label">Currency</InputLabel>
              <Select
                labelId="currency-label"
                id="currency"
                value={currency}
                label="Currency"
                onChange={handleCurrencyChange}
              >
                {currencies.map((cur) => (
                  <MenuItem key={cur.code} value={cur.code}>
                    {cur.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          <div className="control_group w_33">
            <TextField
              fullWidth
              id="valueOfPoint"
              label="Value of 1 Point"
              placeholder="Enter value of 1 point"
              value={valueOfPoint}
              onChange={handleValueChange}
              type="number"
              inputProps={{ step: "0.01", min: "0" }}
            />
          </div>

          <div className="form_btn" style={{ marginTop: "1rem" }}>
            <Button className="btn btn_primary" onClick={handleSave}>
              Save
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddLoyalty;
